import { Injectable, inject } from '@angular/core';
import {
  ApiDependencyProviderService,
  CollectionRequest,
  CollectionResponse,
  HttpParams,
} from '@web/common';
import { map, Observable } from 'rxjs';
import { WarehouseOwnerCollectionItemResponse } from '../responses/warehouse-owner-collection-item.response';
import { WarehouseOwnerDetailsResponse } from '../responses/warehouse-owner-details.response';
import { Guid } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class WarehouseOwnerApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchCollection(
    request: CollectionRequest,
    cacheable = false,
  ): Observable<CollectionResponse<WarehouseOwnerCollectionItemResponse>> {
    const path = 'admin/dictionary/owner';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      this.provider.httpHelper.collectionRequestToQueryParams(request),
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .skipByLoadingInterceptor()
      .withOptionalCacheInterceptor(() => cacheable)
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToCollectionResponse(
            WarehouseOwnerCollectionItemResponse,
          ),
        ),
      );
  }

  public fetchDetailsById(
    id: Guid,
    cacheable = false,
  ): Observable<WarehouseOwnerDetailsResponse> {
    const path = `admin/dictionary/owner/${HttpParams.Id}`;
    const url = this.provider.httpUrlFactory.withParams(this.hostUrl(), path, {
      [HttpParams.Id]: id,
    });
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .skipByLoadingInterceptor()
      .withOptionalCacheInterceptor(() => cacheable)
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToResponse(
            WarehouseOwnerDetailsResponse,
          ),
        ),
      );
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Warehouse;
  }
}
